module.exports = __webpack_public_path__ + "static/media/Luke Skywalker.066cc5a8.jpg";